import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { InputField, DisabledInputField, GenericInput } from '../Common/inputField';
import { Input } from 'react-bootstrap';

import GenericSelection from '../Common/GenericSelection';
import { isLE } from '../../actions/root_url';

class NewRouteModal extends Component {
  static getDayOptions() {
    const days = [
      { value: 'Monday', label: <Translate value="Monday" /> },
      { value: 'Tuesday', label: <Translate value="Tuesday" /> },
      { value: 'Wednesday', label: <Translate value="Wednesday" /> },
      { value: 'Thursday', label: <Translate value="Thursday" /> },
      { value: 'Friday', label: <Translate value="Friday" /> },
      { value: 'Saturday', label: <Translate value="Saturday" /> },
      { value: 'Sunday', label: <Translate value="Sunday" /> }
    ];
    const dayOptions = [];
    days.map((day) => {
      dayOptions.push({ value: day.value, label: day.label });
    });
    return dayOptions;
  }

  static pad(number) {
    let leadingZeros;
    if (number < 10) {
      leadingZeros = '00';
    } else if (number > 10 && number < 100) {
      leadingZeros = '0';
    } else {
      leadingZeros = '';
    }
    return leadingZeros;
  }

  constructor(props) {
    super(props);
    this.state = {
      day: '',
      routeLetter: '',
      routes: [],
    };

    this.setSelected = this.setSelected.bind(this);
    this.addNewRoute = this.addNewRoute.bind(this);
  }

  setSelected(e) {
    let routeLetter;
    if (e.value === 'Monday') {
      routeLetter = 'MO';
    } else if (e.value === 'Tuesday') {
      routeLetter = 'TU';
    } else if (e.value === 'Wednesday') {
      routeLetter = 'WE';
    } else if (e.value === 'Thursday') {
      routeLetter = 'TH';
    } else if (e.value === 'Friday') {
      routeLetter = 'FR';
    } else if (e.value === 'Saturday') {
      routeLetter = 'SA';
    } else if (e.value === 'Sunday') {
      routeLetter = 'SU';
    }
    
    const routes = this.props.routes.filter(route => route.RouteNum.includes(routeLetter));
    this.setState({ day: e.value, routes, routeLetter });
  }

  addNewRoute() {
    let data = {};
    if (isLE) {
      data.route_name = this.state.route_name;
    } else {
      data.day = this.state.day;
    }
    this.props.action(data);
  }

  renderNewRoute() {
    const lastIndex = this.state.routes.length - 1;
    const numString = (lastIndex === -1) ? '0' : this.state.routes[lastIndex].RouteNum.substr(2);
    const routesDigits = parseInt(numString, 10) + 1;
    const leadingZeros = NewRouteModal.pad(routesDigits);
    
    return `${this.state.routeLetter}${leadingZeros}${routesDigits}`;
  }

  renderRoutes() {
    if (!this.state.routes.length === 0) {
      return <div />;
    }
    const itemList = this.state.routes.map(route => <li>{route.RouteNum}</li>);
    return itemList;
  }

  render() {
    const dayOptions = NewRouteModal.getDayOptions();
    if (isLE) {
      return (
        <div id="new-route-modal">
          <Row>
            <Col xs={12}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="route_name" /></label>
                <div className="col-xs-9">
                  {/* <Field name="route_name" component={InputField} /> */}
                <Input 
                  standalone
                  type={'text'}
                  onChange={e => this.setState({ route_name: e.target.value })}
                  value={this.state.route_name}
                />
                </div>
              </div>
            </Col>
          </Row>
          <div className="add-button">
            <Button
              bsStyle="primary"
              disabled={this.props.savingNewRoute}
              onClick={() => { this.addNewRoute(); }}
            >
              <em className="fa fa-plus" /><Translate value="add" />
            </Button>
          </div>
        </div>
      )
    }
    return (
      <div id="new-route-modal">
        <div className="selection">
          {
            GenericSelection({
              translation: <Translate value="select_day" />,
              options: dayOptions,
              value: this.state.day,
              setSelected: this.setSelected,
            })
          }
        </div>
        <Row>
          <Col xs={12}>
            <ul>
              {this.renderRoutes()}
            </ul>
          </Col>
        </Row>
        { this.state.day &&
          <div>
            <div className="new-route-label">
              <Translate value="new_route" /><span className="colon">:</span>
              {this.renderNewRoute()}
            </div>
            <div className="add-button">
              <Button
                bsStyle="primary"
                disabled={this.props.savingNewRoute}
                onClick={() => { this.addNewRoute(); }}
              >
                <em className="fa fa-plus" /><Translate value="add" />
              </Button>
            </div>
          </div>
        }
      </div>
    );
  }
}

NewRouteModal.defaultProps = {
  routes: {},
};

NewRouteModal.propTypes = {
  routes: PropTypes.object,
  action: PropTypes.func.isRequired,
  saveNewRoute: PropTypes.func.isRequired,
  savingNewRoute: PropTypes.bool.isRequired,
};

export default NewRouteModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/NewRouteModal.jsx